var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOil2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5999C16.885 9.5999 17.6 8.8849 17.6 7.9999C17.6 7.1149 16.885 6.3999 16 6.3999H9.6C8.715 6.3999 8 7.1149 8 7.9999C8 8.8849 8.715 9.5999 9.6 9.5999H11.2V11.1999H7.2H4.8H2.4C1.075 11.1999 0 12.2749 0 13.5999V16.8399C0 17.7899 0.56 18.6499 1.425 19.0349L4.8 20.5349V21.5999C4.8 22.9249 5.875 23.9999 7.2 23.9999H20.155C21.075 23.9999 21.945 23.6049 22.555 22.9149L31.675 12.5849C32.29 11.8899 31.66 10.8149 30.755 11.0099L22.4 12.7999L19.875 11.5399C19.43 11.3199 18.94 11.1999 18.445 11.1999H14.4V9.5999H16ZM4.8 13.5999V17.9049L2.4 16.8399V13.5999H4.8Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil2);
export default __webpack_public_path__ + "static/media/oil-2.f8ac48f95067eea191d0059507096576.svg";
export { ForwardRef as ReactComponent };